import { render } from "./AgreementModal.vue?vue&type=template&id=aabafd1c"
import script from "./AgreementModal.vue?vue&type=script&lang=js"
export * from "./AgreementModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__